import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  EDealType,
  EOfferType,
} from 'shared/repositories/demand/entities/public_v1_is_suitable_offers_for_cpd/OfferData';
import {
  fetchIsSuitableOffersForCpd,
  TIsSuitableOffersForCpdResponse,
} from 'shared/repositories/demand/v1/is-suitable-offers-for-cpd';
import { addressSelector, selectOfferPriceRub } from 'shared/selectors';
import { IThunkActionCreator } from 'shared/store';

import { setAvailableCpd } from './';

export const getIsCpdAvailable = (): IThunkActionCreator<Promise<void>> => async (dispatch, getState, context) => {
  try {
    const state = getState();
    const price = selectOfferPriceRub(state);
    const address = addressSelector(state);
    const addressString = address.map(addr => addr.fullName).join(', ');

    const res = (await fetchIsSuitableOffersForCpd({
      httpApi: context.httpApi,
      parameters: {
        data: [
          {
            address: addressString,
            dealType: EDealType.Sale,
            offerType: EOfferType.Flat,
            price,
          },
        ],
      },
    })) as TIsSuitableOffersForCpdResponse;

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: res.statusCode,
        domain: 'getIsCpdAvailable.ts',
        message: res.response.message as string,
      });
    }

    dispatch(setAvailableCpd(res.response.response[0]));
  } catch (e) {
    context.logger.error(e);

    dispatch(setAvailableCpd(false));
  }
};
